import React from "react";
import EditBook from "../../img/EditBook.png";
// import Filters from "./Filters";
import {Link} from "react-router-dom";
// import axios from "axios";
import {connect} from "react-redux";
import {fetch_booklists} from "./action/books.js";

class MybookList extends React.Component{
    constructor(props) {
      super(props);
      this.state = {
         "ov": false,
         "books": props.bookLists
      };
    }
    ov = () => {
        this.setState({"ov": false});
    };
    ovv = () => {
        this.setState({"ov": true});
    };
    sortLast = e => {
        const books = this.state.books;
        books.reverse()
        this.setState({books: books})
    };
    sortNone = e=> {
        const oldBooks = this.state.oldBooks;
        const books = this.state.books;
        if(oldBooks.reverse() === books){
            console.log(books)
            this.setState({books: books})
        }
    };
    RecView = e=>{
        const books = this.state.books;
        books.sort(function(a, b){
            return new Date(b.recentlyViewed) - new Date(a.recentlyViewed)
        })
        this.setState({books: books})
    };
    dateCreatedOn = e=>{
        const books = this.state.oldBooks;
        for(var i = 0; i< books.length; i++){
            var dateCreatedOn = new Date(books[i].dateCreatedOn);
            var dateCreatedOn2 = new Date(e);
            var val1 = dateCreatedOn.getDate()+dateCreatedOn.getMonth()+dateCreatedOn.getYear();
            var val2 = dateCreatedOn2.getDate()+dateCreatedOn2.getMonth()+dateCreatedOn2.getYear();
            if(val1 === val2){
                books.sort(function(val1, val2){
                    return val1 === val2
                })
                this.setState({books: books});
            }else{
                this.setState({books: []})
            }
        }
    };
    bookType = e=>{
        const books = this.state.oldBooks;
        const oldBooks = this.state.oldBooks;
        for(var i = 0; i< books.length; i++){
    
            if(e !== "None"){
                var val1 = books[i].book_type;
                var val2 = e;
                if(val1 === val2){
                books.sort(function(val1, val2){
                    console.log(val2)
                    return val1 === val2
                })
                console.log(books)
                this.setState({books: books});}else{
                    this.setState({books: []})
                }
            }else{
                this.setState({books: oldBooks})
            }
        }
    };
    clear = e => {
        const oldBooks = this.state.oldBooks;
        this.setState({books: oldBooks});
    };
    render(){
        return(
            <div className="book_page">
                <div className="books_container">
                    {this.props.searchedContents ? this.props.searchedContents!==[] && this.props.length!==0 && this.props.length === this.props.searchedContents.length &&
                        this.props.searchedContents.map(function(item){
                        return <Book 
                            key={item.bookListId}
                            bookListId = {item.bookListId}
                            title={item.book_title}
                            description={item.book_description} 
                            chapters={item.total_chapters}
                            pages={item.total_pages}
                            type={item.book_type}
                            imageSrc={item.book_cover}
                        />
                    }):this.state.books !== [] ?
                    this.state.books.map(function(item){
                        return <Book 
                            key={item.bookListId}
                            bookListId = {item.bookListId}
                            title={item.booklist_title}
                            description={item.booklist_description}
                            total_noof_books={item.total_noof_books}
                            type={item.book_type}
                            imageSrc={item.book_cover}
                        />
                    }):<div className="loader">
                        <div></div>
                        <h1>Please Wait...</h1>
                    </div>
                    }
                </div>
            </div>
        );
    }
};

const Book = (props) => {
    return(
        <div className="bookl">
        <Link to={"/main/bookLists/"+props.bookListId} className="pagalHain">
            <div className="right2Section">
                <h2 className="book_title">{props.title}</h2>
                <div className="total_section">
                    <h6>Total Number Of Books: <b>{props.total_noof_books}</b></h6>
                </div>
                <p className="description">{props.description.substring(0, 95)} {props.description.length > 94 && (<span className="text-danger"><b><u>Read More...</u></b></span>)}</p>
            </div>
        </Link>
            <div className="editBooklist">
                <Link to={"/main/editBookL/"+props.bookListId}><img src={EditBook} alt="Edit Book" className="editBook" /></Link>
            </div>

            <Link to={"/main/bookLists/"+props.bookListId} className="footerright">
                <div className="expandLi"></div>
            </Link>
            </div>
    )
};

// const booksArray = [
//                 {"id": "1","title": "Marigold", 
//                 "description": "This is the Description of the Book. Click on this Book Component to view more. It will open a new window",
//                 "chapters": "40", 
//                 "pages": "110", 
//                 "type": "PDF", 
//                 "imageSrc": "https://bn1305files.storage.live.com/y4merdutAU-qnW7qtMPSd1DuBSPElKc0FFWiCThL37NYTPXjFKrYov2N0449feeMGA09BYufO9NlBkulweJm1APpKaY1Zn9-GJr95CArH-8iXmPARR6RzSV6oMqG6wEZw2w2Au2rHh7YmuU8G3Bjvv8paxXb2rxUfhXMHG8gANKuTO6g0Q1hTx4YpFuKOepLsEw?width=1500&height=2010&cropmode=none"},
               
//                 {"id": "2","title": "The Art Of Software Testing", 
//                 "description": "This is the Description of the Book. Click on this Book Component to view more. It will open a new window",
//                 "chapters": "151", 
//                 "pages": "509", 
//                 "type": "HTML", 
//                 "imageSrc": "https://bn1305files.storage.live.com/y4mwn52L-eanuKML0gLxGrVu60cTFm2zZv-LFJRLJ1Cc5i6L-6OF7IUvXAauqB-KWvanpWJly4pmRgY10RyAuOsbSIiXR7fHLYtG67PJcCXyIG4n_aymfWAzj5RBKkEmUfGkcUVgC1CRTxkt7Xz8RR0u4MRPI90zoTYHX7Cp6pyfKSGCJHUfFHTRYtKUPyZ2NQZ?width=333&height=499&cropmode=none"},
                
//                 {"id": "3","title": "Operating System Concepts", 
//                 "description": "This is the Description of the Book. Click on this Book Component to view more. It will open a new window",
//                 "chapters": "243", 
//                 "pages": "909", 
//                 "type": "PDF", 
//                 "imageSrc": "https://bn1305files.storage.live.com/y4mhIa7vf_8nYgOQMO9MVac-147dyc7O4c7aElCYxiHPRAfWu_MwuyUpyvVmwD1siXPIL5bnR5KsBb9JxcCYCqxNrQyil61bxgACJhQdDY2qzinoHsusPUIlw6nIsCL6Iur3HeKia6EIo-G0jIPg_wk4K36uY7gtq15_2bzuXwiLBWjZfRMre4rJz8DhB4Sj-V8?width=342&height=500&cropmode=none"},
//                 {"id": "4","title": "C++", 
//                 "description": "This is the Description of the Book. Click on this Book Component to view more. It will open a new window",
//                 "chapters": "151", 
//                 "pages": "509", 
//                 "type": "PDF", 
//                 "imageSrc": "https://bn1305files.storage.live.com/y4mKn7RQioz8UkBVBbdpEvmutdaWGLQ_DiDBJZX4ir64fRKrjZixAJdivzrzsbYC65FZQm5pAFeOWcmMWzMbPL5HdNMvlvQLfqhykGqjMVSQwmxNr8UXYwEmI2Z16DrPCBdQogqUc3mvdKY07vsuG5JGS1sTCbrzu7Mwm-qzDNm3BJoGypPbb6yQjl2bt0TgThM?width=384&height=499&cropmode=none"}];


function mapStateToProps(state){
    return {
        isAuthenticated: !!state.user.name, 
        bookLists: state.AllBooklists.bookLists, 
        searchedContents: state.SearchBook.books,
        length: state.SearchBook.length
    }
}

export default connect(mapStateToProps, {fetch_booklists})(MybookList);